import { render, staticRenderFns } from "./DSEditIcon.vue?vue&type=template&id=15f29f7f&scoped=true&"
import script from "./DSEditIcon.vue?vue&type=script&lang=js&"
export * from "./DSEditIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f29f7f",
  null
  
)

export default component.exports